import React from "react";
import LayoutHeader from "../../Components/Layouts/LayoutHeader";
import Footer from "../../Components/Common/Footer";

const MainLayout = ({ children }) => {
  return (
    <div className="app-admin-wrap layout-sidebar-large">
      <LayoutHeader />
      <div
        className="main-content-wrap d-flex flex-column"
        style={{ background: "rgba(197, 181, 224,0.1)" }}
      >
        <div className="main-content">{children}</div>
        <div className="py-5" />
        {/* <Footer /> */}
      </div>
    </div>
  );
};

export default MainLayout;
